import React, { useMemo } from "react";
import {
  ContainerHeadline,
  Headline,
  SeriesHeadline,
  TitleCity,
  TitleImg,
  Box,
} from "./BannerCity.styled";

import { JadwalKlasemenContainer } from "../../../../pages/v2/HomeDetails/HomeDetails.styled";
import Card from "../../../atoms/NewCard";
import { usePageContextState } from "../../../../context/PageContext";

import { func } from "../../../../utils";
import _function from "../../../../utils/function";
import Section from "../../../atoms/Section";
import {
  BannerWrapper,
  Container,
  ContentBottom,
  HintScroll,
  PialaByuImg,
  ScrollDownIcon,
} from "../Banner/Banner.styled";
import { Spacer, Text } from "../../..";
import useWindowSize from "../../../../hooks/useWindowSize";
import { useNavigate, useParams } from "react-router-dom";

import { Container as ContainerGrid, Row, Col } from "react-grid-system";

import CardRegister from "../../../atoms/CardRegister";
import moment from "moment";

const jabarCity = ["subang", "bandung", "garut", "cirebon", "bogor"];

const handleScroll = () => {
  _function.scrollTo("home-detail-content");
};

const BannerCity = ({ data, slug, children }) => {
  const { isLive } = usePageContextState();
  // const handleScroll = () => {
  //   _function.scrollTo("event");
  // };
  const loc = data?.location;
  const city = data?.city || "";
  const event_start_date = data?.event_start_date;
  const event_end_date = data?.event_end_date;
  const regist_url = data?.registration_url;
  const isSameMonthEvent =
    moment(event_start_date).format("MMMM") === moment(event_end_date).format("MMMM");
  const labelStartEvent = moment(event_start_date).format(isSameMonthEvent ? "D" : "DD MMMM");
  const eventDate = `${labelStartEvent} - ${moment(event_end_date)?.format("D MMMM")}`;

  const { size } = useWindowSize();
  const navigate = useNavigate();

  const series = jabarCity.includes(city.toLowerCase()) ? "JAWA BARAT SERIES" : "";

  const isSmallScreen = (size?.height || 0) <= 667;
  const isExtraSmallScreen = (size?.width || 0) <= 375 && (size?.height || 0) <= 600;
  const isMobileView = (size?.width || 0) <= 830;

  const MobileBanner = () => {
    return (
      <>
        <Container justifyContent={"center"} display={"flex"}>
          {/* <ImgBanner src={func.getStaticImg("bg/banner-kv.png")} alt="kv" /> */}
          <TitleImg
            marginTop={isExtraSmallScreen ? "20px" : isSmallScreen ? "25px" : "35px"}
            src={func.getStaticImg("illustration/conference/title.png")}
            alt="title"
            maxWidth={"304px"}
            scale={isSmallScreen || isExtraSmallScreen ? "scale(0.8)" : "scale(0.95)"}
          />
        </Container>
        <Container display="inline">
          <Container
          // backgroundPosition={"0px -62px,0 19px,-20px -16px"}
          // backgroundImage={func.getStaticImg(
          //   "illustration/conference/shadow.svg"
          // )}
          // backgroundImage2={func.getStaticImg("bg/ribbon-banner.svg")}
          // backgroundImage3={func.getStaticImg("bg/shine-bg.svg")}
          >
            <PialaByuImg
              margin={
                isExtraSmallScreen
                  ? "-50px auto 0px auto"
                  : isSmallScreen
                  ? "-40px auto 0px auto"
                  : "-44px auto 0px auto"
              }
              src={func.getStaticImg("illustration/conference/kv-desktop.png")}
              scale={isExtraSmallScreen ? "scale(0.8)" : isSmallScreen ? "scale(0.95)" : "scale(1)"}
              maxHeight={isMobileView ? "254px" : "425px"}
            />
          </Container>
        </Container>
        {!!series && (
          <TitleCity src={func.getStaticImg("illustration/jawa-barat-title-banner.svg")} />
        )}
        {/* {!!series && <SeriesHeadline>{series}</SeriesHeadline>} */}
        {/* {currentDate.isBefore(startDate, "day") && !!regist_url ? (
          <Container
            justifyContent={"center"}
            display={"flex"}
            margin="0.5vh 0 0 0"
          >
            <CardRegister data={data} />
          </Container>
        ) :  */}
        <>
          <Container justifyContent={"center"} display={"flex"}>
            <Box
              onClick={() => {
                // handleBoxStep(0);
              }}
            >
              <Text
                color="white"
                size="small"
                weight="bold"
                removeGap
                style={{ fontSize: "1.6rem" }}
              >
                <ContainerHeadline>
                  {loc && (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <img src={func.getStaticImg("/illustration/pin-location.svg")} />
                      <Headline>{loc}</Headline>
                    </div>
                  )}

                  {city && eventDate && <Headline>{`${city}, ${eventDate}`}</Headline>}
                </ContainerHeadline>
              </Text>
            </Box>
          </Container>

          <Container justifyContent={"center"} display={"flex"}>
            <JadwalKlasemenContainer>
              {isLive && (
                <Card
                  backgroundColor="white"
                  text="Nonton Live Streaming"
                  srcImg="/illustration/home-streaming.svg"
                  onClick={() => window.open(data?.video_url, "_blank")}
                />
              )}
              <Card
                backgroundColor="white"
                text="Jadwal & Hasil Pertandingan"
                srcImg="/illustration/home-jadwal-v2.svg"
                onClick={() => navigate(`/${slug}/jadwal-pertandingan`)}
              />
              {isLive && (
                <hr
                  style={{
                    flexBasis: "100%",
                    height: "0",
                    margin: "0",
                    border: "0",
                  }}
                />
              )}
              <Card
                backgroundColor="white"
                text="Klasemen & Statistik"
                srcImg="/illustration/home-klasemen-v2.svg"
                onClick={() => navigate(`/${slug}/klasemen-pertandingan`)}
              />
              <Card
                backgroundColor="white"
                text="Info Kota Lainnya"
                srcImg="/illustration/icon-piala-byu-2024-card.png"
                onClick={() => navigate(`/main`)}
              />
            </JadwalKlasemenContainer>
          </Container>
        </>
      </>
    );
  };

  const DesktopBanner = () => {
    return (
      <Row style={{ maxWidth: "1440px", alignSelf: "center" }}>
        <Col md={6}>
          <PialaByuImg
            margin={"64px auto auto auto"}
            src={func.getStaticImg("illustration/conference/kv-desktop.png")}
            maxHeight={"600px"}
          />
        </Col>
        <Col md={6} lg={5}>
          <Container justifyContent={"center"} display={"flex"} flexDirection="column">
            <TitleImg
              marginTop={"12vh"}
              src={func.getStaticImg("illustration/conference/title-d.png")}
              alt="title"
              //maxWidth={"550px"}
              position="inherit"
              display="flex"
            />
            {!!series && (
              <TitleCity src={func.getStaticImg("illustration/jawa-barat-title-banner.svg")} />
            )}
            {/* {!!series && <SeriesHeadline>{series}</SeriesHeadline>} */}
            {/* {currentDate.isBefore(startDate, "day") && !!regist_url ? (
              <Container
                justifyContent={"center"}
                display={"flex"}
                margin="0.5vh 0 0 0"
              >
                <CardRegister data={data} />
              </Container>
            ) :  */}
            <>
              <Container
                justifyContent={"center"}
                display={"flex"}
                margin="0.5vh 0 0 0"
                className="min-w-[550px]"
              >
                <Box
                  onClick={() => {
                    // handleBoxStep(0);
                  }}
                >
                  <Text
                    color="white"
                    size="small"
                    weight="bold"
                    removeGap
                    style={{ fontSize: "1.6rem" }}
                  >
                    <ContainerHeadline>
                      {loc && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={func.getStaticImg(
                              isMobileView
                                ? "/illustration/pin-location.svg"
                                : "/illustration/pin-location-d.svg",
                            )}
                          />
                          <Headline>{loc}</Headline>
                        </div>
                      )}

                      {city && eventDate && <Headline>{`${city}, ${eventDate}`}</Headline>}
                    </ContainerHeadline>
                  </Text>
                </Box>
              </Container>

              <Container justifyContent={"center"} display={"flex"} margin="2.4vh 0 0 0">
                <JadwalKlasemenContainer>
                  {isLive && (
                    <Card
                      backgroundColor="white"
                      text="Nonton Live Streaming"
                      srcImg="/illustration/home-streaming.svg"
                      onClick={() => window.open(data?.video_url, "_blank")}
                    />
                  )}
                  <Card
                    backgroundColor="white"
                    text="Jadwal & Hasil Pertandingan"
                    srcImg="/illustration/home-jadwal-v2.svg"
                    onClick={() => navigate(`/${slug}/jadwal-pertandingan`)}
                  />
                  {isLive && (
                    <hr
                      style={{
                        flexBasis: "100%",
                        height: "0",
                        margin: "0",
                        border: "0",
                      }}
                    />
                  )}
                  <Card
                    backgroundColor="white"
                    text="Klasemen & Statistik"
                    srcImg="/illustration/home-klasemen-v2.svg"
                    onClick={() => navigate(`/${slug}/klasemen-pertandingan`)}
                  />
                  <Card
                    backgroundColor="white"
                    text="Info Kota Lainnya"
                    srcImg="/illustration/icon-piala-byu-2024-card.png"
                    onClick={() => navigate(`/main`)}
                  />
                </JadwalKlasemenContainer>
              </Container>
            </>
            <Container justifyContent={"center"} display={"flex"}>
              <HintScroll onClick={handleScroll}>{"Scroll ke bawah"}</HintScroll>
            </Container>
            <Container justifyContent={"center"} display={"flex"}>
              <ScrollDownIcon
                onClick={handleScroll}
                alt="scroll-down"
                src={func.getStaticImg("icon/scroll-down.svg")}
              />
            </Container>
          </Container>
        </Col>
        <Col>
          {/* <Container
            justifyContent={"center"}
            display={"flex"}
            margin="-5vh 0 0 0"
          >
            <HintScroll onClick={handleScroll}>{"Scroll Ke bawah"}</HintScroll>
          </Container>
          <Container justifyContent={"center"} display={"flex"}>
            <ScrollDownIcon
              onClick={handleScroll}
              alt="scroll-down"
              src={func.getStaticImg("icon/scroll-down.svg")}
            />
          </Container> */}
        </Col>
      </Row>
    );
  };

  return (
    <BannerWrapper
      id="banner"
      // backgroundImage={func.getStaticImg(
      //   isMobileView
      //     ? "illustration/conference/backdrop.svg"
      //     : "illustration/conference/backdrop-desktop.svg"
      // )}
      zIndex={2}
      position="relative"
      border={"1px transparent"}
      borderBottomLeftRadius={isMobileView ? "16px" : "0"}
      borderBottomRightRadius={isMobileView ? "16px" : "0"}
      height={isMobileView ? "95vh" : "100vh"}
    >
      {isMobileView ? <MobileBanner /> : <DesktopBanner />}
    </BannerWrapper>
  );
};

export default BannerCity;
